import React from 'react';
import { connect } from 'react-redux';
import NbReclamationsClotureesIndicateur from './NbReclamationsClotureesIndicateur';
import { fetchReclamationsClotureesIfNeeded } from 'store/reclamation/indicateursActions';
import { updateRechercheCriteres } from 'store/reclamation/reclamationsActions';
import { ReclamationFiltre } from '../../../../../constants';

class NbReclamationsClotureesIndicateurContainer extends React.Component {

    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        this.props.fetchReclamationsClotureesIfNeeded();
    }


    componentDidUpdate(prevProps) {
        if (this.props.didInvalidate && !prevProps.didInvalidate) {
            this.props.fetchReclamationsClotureesIfNeeded();
        }
    }

    handleClick() {
        this.props.updateRechercheCriteres({
            filtre: ReclamationFiltre.Cloturees
        });
    }

    render() {
        return <NbReclamationsClotureesIndicateur isLoading={this.props.isLoading} count={this.props.valeur} onClick={this.handleClick} />;
    }
}

const mapStateToProps = state => ({
    valeur: state.reclamation.indicateurs.cloturees.valeur,
    isLoading: state.reclamation.indicateurs.cloturees.isLoading,
    didInvalidate: state.reclamation.indicateurs.creees.didInvalidate
});

const mapDispatchToProps = dispatch => ({
    fetchReclamationsClotureesIfNeeded: () => dispatch(fetchReclamationsClotureesIfNeeded()),
    updateRechercheCriteres: criteres => dispatch(updateRechercheCriteres(criteres))
});

export default connect(mapStateToProps, mapDispatchToProps)(NbReclamationsClotureesIndicateurContainer);